"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var workflow_1 = require("@newfront-insurance/workflow");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var uuid_1 = require("uuid");
var custom_cancel_selector_1 = __importDefault(require("../components/custom-cancel-selector"));
var custom_nonrenew_selector_1 = __importDefault(require("../components/custom-nonrenew-selector"));
var lost_to_bor_selector_1 = __importDefault(require("../components/lost-to-bor-selector"));
var newfront_nonrenew_selector_1 = __importDefault(require("../components/newfront-nonrenew-selector"));
var schemas_1 = require("../lib/schemas");
var types_1 = require("../lib/types");
function SelectSecondaryReason(props) {
    var context = props.context, onSubmit = props.onSubmit, onBack = props.onBack;
    var primaryReason = context.primaryReason;
    var id = uuid_1.v4();
    var _a = (function () {
        switch (primaryReason) {
            case types_1.PrimaryReason.CUSTOMER_CANCEL:
                return {
                    option: types_1.customerCancel,
                    defaultValue: types_1.NO_LONGER_NEED_INSURANCE_POLICY_LOSS_REASONS[0],
                    submitButtonText: 'Next',
                };
            case types_1.PrimaryReason.CUSTOMER_NONRENEW:
                return {
                    option: types_1.customerNonrenew,
                    defaultValue: types_1.NO_LONGER_NEED_INSURANCE_POLICY_LOSS_REASONS[0],
                    submitButtonText: 'Submit',
                };
            case types_1.PrimaryReason.NEWFRONT_NONRENEW:
                return {
                    option: types_1.newfrontNonrenew,
                    defaultValue: types_1.CUSTOMER_UNRESPONSIVE_POLICY_LOSS_REASONS[0],
                    submitButtonText: 'Submit',
                };
            case types_1.PrimaryReason.LOST_TO_BOR:
            default:
                return {
                    option: types_1.lostToBor,
                    defaultValue: types_1.CLIENT_PREFERENCE_POLICY_LOSS_REASONS[0],
                    submitButtonText: 'Submit',
                };
        }
    })(), option = _a.option, defaultValue = _a.defaultValue, submitButtonText = _a.submitButtonText;
    var form = formik_1.useFormik({
        initialValues: {
            primaryReason: context.primaryReason,
            secondaryReason: context.secondaryReason || defaultValue,
            effectiveDate: context.effectiveDate,
        },
        validateOnMount: true,
        validationSchema: schemas_1.verifySecondaryReasonSchema,
        onSubmit: onSubmit,
    });
    var values = form.values, onChange = form.setFieldValue;
    if (!option) {
        return (react_1.default.createElement(StyledWrapper, null,
            react_1.default.createElement(core_ui_1.Padding, { top: 88 },
                react_1.default.createElement(core_ui_1.Text, null, "Something went wrong, please go back and try again."))));
    }
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(core_ui_1.Card, null,
            react_1.default.createElement("form", { onSubmit: form.handleSubmit },
                react_1.default.createElement(workflow_1.WorkflowContent.Header, { title: "Tell us why this policy is ending" }),
                react_1.default.createElement(workflow_1.WorkflowContent.Body, null,
                    react_1.default.createElement(core_ui_1.Stack, { gap: 20, direction: "vertical" },
                        react_1.default.createElement(core_ui_1.SelectableOptionRow, { boldLabels: true, isActive: true, key: id, label: option.label, subtitle: option.subtitle, value: option.value }),
                        react_1.default.createElement(core_ui_1.Field, { fieldId: "secondary-reason", label: "Reason" },
                            primaryReason === types_1.PrimaryReason.CUSTOMER_CANCEL && (react_1.default.createElement(custom_cancel_selector_1.default, { onChange: function (e) { return onChange('secondaryReason', e); }, defaultValue: defaultValue, value: form.values.secondaryReason, isRequired: true })),
                            primaryReason === types_1.PrimaryReason.CUSTOMER_NONRENEW && (react_1.default.createElement(custom_nonrenew_selector_1.default, { onChange: function (e) { return onChange('secondaryReason', e); }, defaultValue: defaultValue, value: form.values.secondaryReason, isRequired: true })),
                            primaryReason === types_1.PrimaryReason.NEWFRONT_NONRENEW && (react_1.default.createElement(newfront_nonrenew_selector_1.default, { onChange: function (e) { return onChange('secondaryReason', e); }, defaultValue: defaultValue, value: form.values.secondaryReason, isRequired: true })),
                            primaryReason === types_1.PrimaryReason.LOST_TO_BOR && (react_1.default.createElement(lost_to_bor_selector_1.default, { onChange: function (e) { return onChange('secondaryReason', e); }, defaultValue: defaultValue, value: form.values.secondaryReason, isRequired: true }))),
                        primaryReason === types_1.PrimaryReason.LOST_TO_BOR && (react_1.default.createElement(core_ui_1.Field, { fieldId: "cancellation-effective-date", label: "Effective date of change*", hint: "This will be used as the policy's cancellation effective date" },
                            react_1.default.createElement(core_ui_1.DatePickerInput, { name: "effectiveDate", initValue: form.initialValues.effectiveDate, format: "YYYY-MM-DD", onChange: function (e) { return onChange('effectiveDate', e); } }))))),
                react_1.default.createElement(workflow_1.WorkflowContent.Footer, { actions: {
                        back: {
                            type: 'button',
                            text: 'Back',
                            onClick: function () { return onBack(values); },
                        },
                        next: {
                            type: 'submit',
                            text: submitButtonText,
                            loading: form.isSubmitting,
                            disabled: !form.isValid || form.isSubmitting,
                        },
                    } })))));
}
exports.default = SelectSecondaryReason;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 24px;\n  width: 640px;\n  height: 438px;\n  margin: 0 auto;\n"], ["\n  padding-bottom: 24px;\n  width: 640px;\n  height: 438px;\n  margin: 0 auto;\n"])));
var StyledWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var templateObject_1, templateObject_2;
